/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, qty: NonNullable<unknown> }} Sales_Return_History_ItemInputs */

const vi_sales_return_history_item = /** @type {(inputs: Sales_Return_History_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} × ${i?.qty}`)
};

/**

* @param {Sales_Return_History_ItemInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_history_item = /** @type {((inputs: Sales_Return_History_ItemInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_History_ItemInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_history_item(inputs)
});